import { ROOT_RAPORPUBLIK_ROUTE } from '@/configs/constants'

export interface ProductDataSet {
  id: string
  text: string
  link: string
}

export interface BaseProduct {
  text: string
  extraText?: string
  id: string
  logoUrl: string
  logoExtraUrl?: string
  withText?: boolean
}

export interface ProductDataSets extends BaseProduct {
  datasets: ProductDataSet[]
}

export type ProductCardItem = BaseProduct

export const dataSetBelajarIdAccount: ProductDataSet[] = [
  {
    id: '00001',
    text: 'Aktivasi akun belajarid, chromebook dan pemanfaatan GWFE',
    link: 'https://dapomart.kemdikbud.go.id/collection/2677-pdm-03',
  },
]

export const dataSetMerdekaMengajar: ProductDataSet[] = [
  {
    id: '10001',
    text: 'Peta Persebaran dan Informasi Komunitas dan Informasi Webinar',
    link: 'https://lookerstudio.google.com/u/0/reporting/5f51cd23-b7ca-48ce-bcf2-83f35bc38767/page/p_y040xcgowc/edit',
  },
  {
    id: '10002',
    text: 'Penggunaan Ruang Kolaborasi Merdeka Mengajar',
    link: 'https://lookerstudio.google.com/u/0/reporting/6f8fe11a-4d0a-4403-88cb-b967d14297fa/page/yOvSC',
  },
  {
    id: '10003',
    text: 'Dasbor Kesiapan Implementasi Kurikulum Merdeka',
    link: 'https://lookerstudio.google.com/u/0/reporting/347e4a55-7daf-413e-bb21-635c65ab31ca/page/smCSD',
  },
]

export const getDataSetRapor = ({
  withRaporPublik,
}: {
  withRaporPublik: boolean
}): ProductDataSet[] => {
  return [
    {
      id: '20001',
      text: 'Dasbor Adopsi Rapor Pendidikan',
      link: 'https://lookerstudio.google.com/reporting/731ad797-d508-4539-9571-db96a59a462a',
    },
    {
      id: '20002',
      text: 'Analisa Penggunaan Fitur di Rapor Pendidikan',
      link: 'https://lookerstudio.google.com/u/0/reporting/237b683c-7bb8-44df-911e-a6345c58ac8d/page/p_gnqs9x3r2c',
    },
    withRaporPublik
      ? {
          id: '20003',
          text: 'Rapor Pendidikan untuk Publik',
          link: ROOT_RAPORPUBLIK_ROUTE,
        }
      : null,
  ].filter(Boolean) as ProductDataSet[]
}

export const dataSetArkas: ProductDataSet[] = [
  {
    id: '30001',
    text: 'Informasi Kualitas Data untuk SIPLah',
    link: 'https://datastudio.google.com/reporting/5e565733-acc6-43ce-82c5-24cf08695391',
  },
  {
    id: '30002',
    text: 'Dasbor Pemantauan Keuangan Satdik',
    link: 'https://lookerstudio.google.com/u/1/reporting/cac149df-22ff-4b79-bc79-80021a4acce2/page/p_myslhltj6c',
  },
  {
    id: '30003',
    text: 'Dasbor Penggunaan ARKAS dan SIPLah',
    link: 'https://dapomart.kemdikbud.go.id/dashboard/5511-dashboard-upt-sds',
  },
  {
    id: '30004',
    text: 'Dasbor Monitoring Mitra SIPLah',
    link: 'https://dashboard.siplah.kemdikbud.go.id/dashboard',
  },
]

export const dataSetKampusMerdeka: ProductDataSet[] = [
  {
    id: '40001',
    text: 'Data Informasi terkait Mahasiswa Kampus Merdeka (meliputi MSIB, PMM, IISMA, dan Kampus Mengajar)',
    link: 'https://lookerstudio.google.com/u/1/reporting/30f9e3ac-572c-40c7-b85e-fa406963f32c/page/p_w9n4yozt4c?s=qXZCWIXv9Cc',
  },
  {
    id: '40002',
    text: 'Data Informasi terkait mitra MSIB, Mentor MSIB, Dosen & Koor PT',
    link: 'https://lookerstudio.google.com/u/1/reporting/8d95345f-8bfe-4a5c-bf9d-d872207e3da0/page/p_bac0nd6n4c?s=ildqzl1ukSo',
  },
  {
    id: '40003',
    text: 'Informasi Mengenai Hasil Pelaporan Beban Kerja Dosen (BKD)',
    link: 'https://lookerstudio.google.com/u/0/reporting/302fa6d6-161c-4c34-ab1e-6cef63a614da/page/p_1caefp5z3c/edit',
  },
  {
    id: '40004',
    text: 'Informasi Progress Pelaksanaan MBKM (Termasuk Mandiri & Flagship)',
    link: 'https://lookerstudio.google.com/reporting/eb30f459-ad2d-491e-a8ad-3d92c1bc48eb/page/p_o2jl0fbt5c?s=m-hP8JDG5cU',
  },
]

export const dataSetPlatfromLainnya: ProductDataSet[] = [
  {
    id: '50001',
    text: 'Dasbor Capaian Pengguna dan Adopsi pada Platform Prioritas',
    link: 'https://dapomart.kemdikbud.go.id/dashboard/5493-dashboard-overview-platform-prioritas?sds_-_tahun=2023',
  },
]

const TextAkunBelajarID: ProductCardItem = {
  text: 'Akun Belajar.id',
  id: 'akun-belajar-id',
  logoUrl: '/images/logo-belajarid.png',
}

const TextMerdekaMengajar: ProductCardItem = {
  text: 'Merdeka Mengajar',
  id: 'merdeka-mengajar',
  logoUrl: '/images/logo-merdekamengajar.png',
}

const TextRaporPendidikan: ProductCardItem = {
  text: 'Rapor Pendidikan',
  id: 'rapor-pendidikan',
  logoUrl: '/images/logo-rapor.png',
}

const TextArkasSIPLah: ProductCardItem = {
  text: 'ARKAS',
  extraText: 'SIPLah',
  id: 'arkas-siplah',
  logoUrl: '/images/logo-arkas-v2.png',
  logoExtraUrl: '/images/logo-siplah.png',
}

const TextKampusMerdeka: ProductCardItem = {
  text: 'Kampus Merdeka',
  id: 'kampus-merdeka',
  logoUrl: '/images/logo-kampusmerdeka.png',
}

const TextLainnya: ProductCardItem = {
  text: 'Lainnya',
  id: 'lainnya',
  logoUrl: '/images/logo-kemdikbud.png',
  withText: true,
}

export const productCards: ProductCardItem[] = [
  TextAkunBelajarID,
  TextMerdekaMengajar,
  TextRaporPendidikan,
  TextArkasSIPLah,
  TextKampusMerdeka,
  TextLainnya,
]

export const getProductDataSets = ({
  withRaporPublik,
}: {
  withRaporPublik: boolean
}): ProductDataSets[] => {
  return [
    {
      ...TextAkunBelajarID,
      datasets: dataSetBelajarIdAccount,
      logoUrl: '/images/logo-belajarid-small.png',
      withText: true,
    },
    {
      ...TextMerdekaMengajar,
      datasets: dataSetMerdekaMengajar,
      logoUrl: '/images/logo-merdekamengajar-small.png',
      withText: true,
    },
    {
      ...TextRaporPendidikan,
      datasets: getDataSetRapor({ withRaporPublik }),
      logoUrl: '/images/logo-rapor-small.png',
      withText: true,
    },
    {
      ...TextArkasSIPLah,
      datasets: dataSetArkas,
      logoUrl: '/images/logo-arkas-small-v2.png',
      logoExtraUrl: '/images/logo-siplah-small.png',
      withText: true,
    },
    {
      ...TextKampusMerdeka,
      datasets: dataSetKampusMerdeka,
      withText: true,
    },
    {
      ...TextLainnya,
      datasets: dataSetPlatfromLainnya,
      withText: true,
    },
  ]
}
